export const SystemColors = {
    white: "#FFFFFF",
    black: "#000000",
    primary: {
        50: "#F7F7F8",
        100: "#F1F2F4",
        200: "#E0E3E6",
        300: "#C9CDD2",
        400: "#94979E",
        500: "#61646B",
        600: "#45484F",
        700: "#272A31",
        800: "#1B1E25",
        900: "#0D1017",
        950: "#03060D"
    },
    accentBlue: {
        50: "#EFF8FE",
        100: "#DFF1FD",
        200: "#B9E5FC",
        300: "#7DD2FB",
        400: "#38BCF7",
        500: "#069CDF",
        600: "#0283C5",
        700: "#0368A0",
        800: "#075884",
        900: "#0C496C",
        950: "#023F62"
    },
    error: {
        50: "#FEF1F1",
        100: "#FFE5E3",
        200: "#FFCACA",
        300: "#FDA1A1",
        400: "#F86F6E",
        500: "#EB4143",
        600: "#D92625",
        700: "#B51D1D",
        800: "#971A1B",
        900: "#7C1A1D",
        950: "#721013"
    },
    warning: {
        50: "#FEF9EA",
        100: "#FEF2C7",
        200: "#FEE68A",
        300: "#FDD14D",
        400: "#FCB823",
        500: "#F6970A",
        600: "#DB7005",
        700: "#B54D09",
        800: "#933C0E",
        900: "#79320E",
        950: "#6F2804"
    },
    success: {
        50: "#EFFCF2",
        100: "#D8F9E1",
        200: "#ACF0C0",
        300: "#7BE79C",
        400: "#40D86E",
        500: "#26BF56",
        600: "#25A244",
        700: "#077F2E",
        800: "#00601A",
        900: "#10451D",
        950: "#063B13"
    },
    gray: {
        50: "#F7F7F8",
        100: "#F1F2F4",
        200: "#E0E3E6",
        300: "#C9CDD2",
        400: "#94979E",
        500: "#61646B",
        600: "#45484F",
        700: "#272A31",
        800: "#1B1E25",
        900: "#0D1017",
        950: "#03060D"
    }
};
export const AdditionalColors = {
    radicalred: {
        50: "#FEF0F1",
        100: "#FDE2E4",
        200: "#FDCCD2",
        300: "#FCA4AE",
        400: "#F97084",
        500: "#F23F5D",
        600: "#DF1D48",
        700: "#BC123C",
        800: "#9C1238",
        900: "#871337",
        950: "#770327"
    },
    oceangreen: {
        50: "#F0FDF7",
        100: "#D4FCEC",
        200: "#AAF7DA",
        300: "#72EDC0",
        400: "#3CD9A0",
        500: "#1BBF82",
        600: "#129C69",
        700: "#127B56",
        800: "#146247",
        900: "#14513C",
        950: "#023F2A"
    },
    indigo: {
        50: "#EEF2FF",
        100: "#E0E7FF",
        200: "#C7D2FE",
        300: "#A6B5FD",
        400: "#828DF9",
        500: "#6265F0",
        600: "#5148E7",
        700: "#4136C8",
        800: "#3730A3",
        900: "#322F82",
        950: "#221F72"
    },
    purple: {
        50: "#F9F4FE",
        100: "#F2E7FE",
        200: "#E8D4FE",
        300: "#D7B3FD",
        400: "#BE83FA",
        500: "#A754F5",
        600: "#9233E8",
        700: "#7D22CC",
        800: "#6921A5",
        900: "#561C84",
        950: "#440A72"
    }
};

//# sourceMappingURL=colors.js.map